import controller from './family-plan-member-same-address-alert-dialog.controller';

export default {
  controller,
  template: require('./family-plan-member-same-address-alert-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-same-address-alert-dialog/family-plan-member-same-address-alert-dialog.component.ts